<template>
  <div>
    <el-form class="toolbar" :inline="true" :model="query" @keyup.enter.native="pageIndex = 1; load()">
      <el-form-item label="车间编码">
        <el-input v-model="query.workShopCode" placeholder="车间编码" size="small" style="width:150px" clearable />
      </el-form-item>
      <el-form-item label="车间名称">
        <el-input v-model="query.workShopName" placeholder="车间名称" size="small" style="width:150px" clearable />
      </el-form-item>
      <el-form-item label="启用状态">
        <el-select v-model="query.isenabled" placeholder="全部" size="small" style="width:120px" clearable>
          <el-option label="启用" value="0" />
          <el-option label="禁用" value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('base:workShop:list')" type="primary" size="small" @click="pageIndex = 1; load()">查询</el-button>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button v-if="isAuth('base:workShop:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="list" border v-loading="loading" style="width:100%" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" header-align="center" align="center" width="60" />
      <el-table-column prop="workShopCode" label="车间编码" header-align="center" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="isAuth('base:workShop:info')" class="code-link" @click="open(scope.row.workShopId, true)">{{ scope.row.workShopCode }}</span>
          <span v-else>{{ scope.row.workShopCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="workShopName" label="车间名称" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="managerName" label="负责人" header-align="center" align="left" width="100" />
      <el-table-column prop="address" label="地址" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="createByName" label="创建人" header-align="center" align="left" width="80" />
      <el-table-column prop="createDate" label="创建日期" header-align="center" align="left" width="100">
        <template slot-scope="scope">{{ (scope.row.createDate || '').substr(0, 10) }}</template>
      </el-table-column>
      <el-table-column prop="isenabled" label="启用状态" header-align="center" align="center" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isenabled === '0'" type="success" size="small">启用</el-tag>
          <el-tag v-else type="danger" size="small">禁用</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="list-pagination" @size-change="sizeChange" @current-change="pageChange"
      :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" />

    <work-shop-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import WorkShopAddOrUpdate from './workShop-add-or-update'

export default {
  name: 'WorkShop',
  components: { WorkShopAddOrUpdate },
  data() {
    return {
      query: { workShopCode: '', workShopName: '', isenabled: '' },
      list: [], pageIndex: 1, pageSize: 20, total: 0, loading: false, hasActivated: false,
      addOrUpdateVisible: false, permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  created() { this.loadPerms(); this.load() },
  activated() {
    if (this.hasActivated) this.load()
    else this.hasActivated = true
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    load() {
      this.loading = true
      request.post('/base/workShop/list', {
        currentPage: this.pageIndex, pageSize: this.pageSize,
        workShopCode: this.query.workShopCode, workShopName: this.query.workShopName, isenabled: this.query.isenabled
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    sizeChange(v) { this.pageSize = v; this.pageIndex = 1; this.load() },
    pageChange(v) { this.pageIndex = v; this.load() },
    open(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(id, !!readonly))
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
</style>
